<template>
  <div 
    class="sc-message--preview" 
    :style="{ backgroundImage: `url('${preview}')` }"
    v-ripple 
    role="button" 
    v-on:click="clicked"
    :id="message.id"
  >
    <div class="sc-message--preview-icon">
      <v-icon large v-if="showStatusIcon">{{statusIcon}}</v-icon>
    </div>

    <div class="sc-message--preview-state">
      <MessageState :state="state" :time="time" background />
    </div>

    
  </div>
</template>

<style>
/* see Message.vue for common styles */
</style>

<script>
  import MessageState from './MessageState.vue'
  import timeUtils from '@utils/timeUtils'

  export default {
    components: { 
      MessageState 
    },
    props: {
      message: {
        type: Object,
        required: true
      },
      progress:{
        type: Number,
        required: true
      }
    },
    data: () => ({
      visible: false,
      preview: null,
    }),
    computed: {
      statusIcon() {
        return this.message.state == this.states.MessageRead ? 'history' : 'visibility'
      },
      showStatusIcon() {
        return this.message.data.ttl != 0 && !this.message.sent
      },
      time() {
        return timeUtils.getShortTime(this.message.time);
      },
      state() {
        return this.message.sent ? this.message.state : null
      },
      backgroundImage() {
        return 'url(' + this.preview + ')'
      }
    },
    mounted() {
      //console.log('-- image: ' + JSON.stringify(this.message))
      this.$nextTick(() => {
        this.preview = 'data:image/jpg;base64,' + this.message.data.preview
      })
    },
    methods:{
      clicked() {
        this.$store.dispatch('showMediaGallery', {
          message: this.message, 
          progress: this.progress
        })
      }
    },
  }
</script>

